export enum AccountMappingTemplateStatus {
    MAPPED = 'mapped',
    NEW = 'new',
    AUTOFILLED = 'autofilled',
    COPY_FROM_OTHER_REPORT = 'COPY_FROM_OTHER_REPORT',
    PREVIOUS_AUTOMATIC_FILL = ' PREVIOUS_AUTOMATIC_FILL',
}
